/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { Box, TextField, Typography, FormGroup, FormControl, Chip } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { ThemeProvider } from "@mui/material/styles";
import { theme, ChipWrapper, OptionsWrapper } from "../Styles/AcademicSubjectsStyle";
import en from '../../nls/en.json';
import { useSelector } from "react-redux";
import { isEmpty, chipDesignValues } from "../../utils/constants";
import { useLocation } from "react-router-dom";

export default function Activities({ getActivities, isEditSuperadmin = false }) {

    const location = useLocation();
    const mentorId = location?.state?.mentorId;
    const { savedAnswer, studentProfileIfo } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
    const { BASIC_INFORMATION } = !isEmpty(mentorId) ? studentProfileIfo : savedAnswer;
    const defaultVals = chipDesignValues(BASIC_INFORMATION?.extracurricular_interests) || [];
    const [selectedactivities, setActivities] = useState(defaultVals);
    const [formData, setFormData] = useState({ activities: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleDeleteChip = (id) => setActivities((selectedMinors) => selectedMinors?.filter((chip) => chip?.id !== id));
    const CharLimit = () => formData?.activities?.length >= 30 || false;
    const handleAddChip = () => {
        const isDuplicate = () => !!selectedactivities?.find((ele) => ele?.name?.toLowerCase() === formData?.activities?.toLowerCase());
        setFormData((prevData) => ({ ...prevData, ["activities"]: "" }));
        if (!isEmpty(formData?.activities?.trim()) && !CharLimit() && !isDuplicate() && selectedactivities?.length < 8) {
            setActivities((prev) => [...prev, { id: Math.floor(Math.random() * 1000), name: formData?.activities }]);
        }
    }

    useMemo(() => {
        getActivities(selectedactivities?.map((item) => item?.name).join(','));
    }, [selectedactivities]);

    return (
        <ThemeProvider theme={theme}>
            <Box>
                <Box variant="form">
                    <Typography variant="h2">{en.GREAT_TEXT}</Typography>
                    <OptionsWrapper>
                        <Typography variant="h3">{en.ACTIVITIES} <span style={{color: "#DC3545" }}>*</span></Typography>
                        <FormGroup sx={{ mt: 2 }}>
                            <FormControl variant="filled">
                                <TextField
                                    name="activities"
                                    type="text"
                                    value={formData.activities}
                                    onChange={(e) => { handleChange(e) }}
                                    label="Activities"
                                    variant={isEditSuperadmin ? "outlined" : "filled"}
                                    required
                                    disabled={selectedactivities?.length === 8}
                                    maxLength={30}
                                    placeholder="Type here and press the button to add"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        endAdornment:
                                            <InputAdornment>
                                                {!CharLimit() && <AddCircleOutlineOutlinedIcon sx={{ cursor: "pointer" }} onClick={() => { handleAddChip() }} />}
                                            </InputAdornment>
                                    }}
                                    error={CharLimit()}
                                    helperText={ CharLimit() ? en.MAX_ALLOWED_CHAR : ""}
                                />
                                <div style={{marginTop: isEditSuperadmin ? "16px" : "" }}>
                                <ChipWrapper>
                                    {selectedactivities?.map((chip) => (
                                        <Chip
                                            key={chip?.id}
                                            label={chip?.name}
                                            onDelete={() => handleDeleteChip(chip.id)}
                                            deleteIcon={<CloseOutlinedIcon />}
                                        />
                                    ))}
                                    {isEmpty(selectedactivities) && (
                                        <Chip label={en.ACTIVITIES_EXAMPLES} variant="outlined" />
                                    )}
                                </ChipWrapper>
                                </div>
                            </FormControl>
                        </FormGroup>
                    </OptionsWrapper>
                </Box>
            </Box>
        </ThemeProvider>
    );
}
